module.exports = __webpack_public_path__ + "img/ncpg.0d332926.png";